import React from "react";
import { useStoreState } from "easy-peasy";
import { toDecimalFractions } from "../../../utils/numberFormatter";

function DateFinanciareBanner() {
    const bilant = useStoreState(
        (state) => state.companyProfile.companyProfile.bilantRecent
    );

    const dateGenerale = useStoreState(
        (state) => state.companyProfile.companyProfile.dateGenerale
    );

    const isMoldovaEnvironment = useStoreState(
        (state) => state.companyProfile.isMoldovaEnvironment
    );

    const currencyLabel = isMoldovaEnvironment ? "MDL" : "RON";

    if (!bilant) {
        // failsafe global: dacă nu avem bilanț, nu afișăm nimic
        return null;
    }

    // helper generic pentru validarea numerelor
    const isFiniteNumber = (value) =>
        typeof value === "number" && Number.isFinite(value);

    // FAILSAFE PE PROCENTE – nu mai arătăm badge-ul dacă e NaN / ∞ / non-number
    const canShowCApct = isFiniteNumber(
        bilant.cifraAfaceriCrestereProcentuala
    );

    const canShowProfitPct = isFiniteNumber(
        bilant.profitCrestereProcentuala
    );

    const canShowProductivitatePct = isFiniteNumber(
        bilant.productivitatePerAngajatCrestereProcentuala
    );

    // Profitabilitate – clamp + failsafe
    const profitabilitateVal = isFiniteNumber(bilant.profitabilitate)
        ? bilant.profitabilitate
        : null;

    const profitabilitateWidth =
        profitabilitateVal !== null
            ? Math.min(100, Math.abs(profitabilitateVal))
            : 0;

    return (
        <div>
            <div className="row">
                <div className="header col-12">
                    <div className="container-fluid">
                        <div className="header-body">
                            <div className="row align-items-end">
                                <div className="col">
                                    <h6 className="header-pretitle">
                                        sparge gheața în conversație folosind indicatorii financiari de la {isMoldovaEnvironment ? 'Data2B' : 'Termene.ro'}
                                    </h6>
                                    <h1 className="header-title">
                                        Date financiare{" "}
                                        {(dateGenerale && dateGenerale.nume) || ""}
                                    </h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row ca-3p">
                {/* Cifră de afaceri */}
                <div className="col-12 col-lg-6 col-xl h-100">
                    <div className="card">
                        <div className="card-body">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h6 className="card-title text-uppercase text-muted mb-2">
                                        Cifră afaceri {bilant.an} {currencyLabel}
                                    </h6>
                                    <span className="h2 mb-2">
                                        {toDecimalFractions(bilant.cifraAfaceri)}
                                    </span>
                                    {canShowCApct && (
                                        <span
                                            className={
                                                bilant.cifraAfaceriCrestereProcentuala >= 0
                                                    ? "badge badge-soft-success mt-n1"
                                                    : "badge badge-soft-danger mt-n1"
                                            }
                                        >
                                            {bilant.cifraAfaceriCrestereProcentuala}% față de{" "}
                                            {bilant.an - 1}
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Profit / Pierdere */}
                <div className="col-12 col-lg-6 col-xl h-100">
                    <div className="card">
                        <div className="card-body">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h6 className="card-title text-uppercase text-muted mb-2">
                                        {bilant.profit > 0 ? "Profit" : "Pierdere"} {bilant.an} {currencyLabel}
                                    </h6>
                                    <span className="h2 mb-2">
                                        {toDecimalFractions(bilant.profit)}
                                    </span>
                                    {canShowProfitPct && (
                                        <span
                                            className={
                                                bilant.profitCrestereProcentuala > 0
                                                    ? "badge badge-soft-success mt-n1"
                                                    : "badge badge-soft-danger mt-n1"
                                            }
                                        >
                                            {bilant.profitCrestereProcentuala}% față de{" "}
                                            {bilant.an - 1}
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Productivitate */}
                <div className="col-12 col-lg-6 col-xl h-100">
                    <div className="card">
                        <div className="card-body">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h6 className="card-title text-uppercase text-muted mb-2">
                                        Productivitate {currencyLabel} / Angajat
                                    </h6>
                                    <span className="h2 mb-2">
                                        {toDecimalFractions(bilant.productivitatePerAngajat)}
                                        <br />
                                    </span>
                                    {canShowProductivitatePct && (
                                        <span
                                            className={
                                                bilant.productivitatePerAngajatCrestereProcentuala > 0
                                                    ? "badge badge-soft-success mt-n1"
                                                    : "badge badge-soft-danger mt-n1"
                                            }
                                        >
                                            {bilant.productivitatePerAngajatCrestereProcentuala}% față
                                            de {bilant.an - 1}
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Profitabilitate */}
                {profitabilitateVal !== null && (
                    <div className="col-12 col-lg-6 col-xl h-100">
                        <div className="card">
                            <div className="card-body">
                                <div className="row align-items-center">
                                    <div className="col">
                                        <h6 className="card-title text-uppercase text-muted mb-2">
                                            Profitabilitate
                                        </h6>
                                        <div className="row align-items-center no-gutters">
                                            <div className="col-12">
                                                <span className="h2 mr-2 mb-4">
                                                    {profitabilitateVal} %
                                                </span>
                                            </div>
                                            <div className="col-12">
                                                <div className="progress progress-sm">
                                                    <div
                                                        className={
                                                            profitabilitateVal > 0
                                                                ? "progress-bar positive"
                                                                : "progress-bar negative"
                                                        }
                                                        role="progressbar"
                                                        style={{
                                                            width: profitabilitateWidth + "%"
                                                        }}
                                                        aria-valuenow={profitabilitateVal}
                                                        aria-valuemin="0"
                                                        aria-valuemax="100"
                                                    ></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default DateFinanciareBanner;